import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import _Object$entries from 'babel-runtime/core-js/object/entries';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import echarts from 'echarts/lib/echarts';
import invariant from '../../utils/invariant';
import shallowEqual from '../../utils/shallowEqual';
import cs from '../../utils/classes';

/**
 * @param {any} listener
 * @returns {void}
 */
function validateListener(listener) {
  invariant(typeof listener === 'function', 'listener expected a function, instead received %s.', listener);
}

var Echart = function (_Component) {
  _inherits(Echart, _Component);

  function Echart() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Echart);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Echart.__proto__ || _Object$getPrototypeOf(Echart)).call.apply(_ref, [this].concat(args))), _this), _this.echartsContainerNode = null, _this.echartsInstance = null, _this._shouldResize = false, _this._echartsContainerRef = function (node) {
      _this.echartsContainerNode = node;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  /**
   * @static
   * @var {object}
   */


  _createClass(Echart, [{
    key: 'componentDidMount',


    /**
     * @public
     * @returns {void}
     */
    value: function componentDidMount() {
      var _props = this.props,
          theme = _props.theme,
          option = _props.option,
          loading = _props.loading,
          onEvents = _props.onEvents,
          echartsContainerNode = this.echartsContainerNode;

      var echartsInstance = echarts.init(echartsContainerNode, theme);
      this.echartsInstance = echartsInstance;
      if (loading) {
        echartsInstance.showLoading();
      }
      this.addListeners(onEvents);
      this.updateChart(option);
    }

    /**
     * @public
     * @param {object} nextProps
     * @returns {void}
     */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var props = this.props,
          echartsInstance = this.echartsInstance;


      if (shallowEqual(nextProps, props)) {
        return;
      }

      var option = props.option,
          width = props.width,
          height = props.height,
          loading = props.loading,
          onEvents = props.onEvents,
          loadingStyle = props.loadingStyle;
      var nextOption = nextProps.option,
          nextWidth = nextProps.width,
          nextHeight = nextProps.height,
          nextOnEvents = nextProps.onEvents,
          nextLoading = nextProps.loading;


      if (!this.listenersEqual(onEvents, nextOnEvents)) {
        this.removeListeners(onEvents);
        this.addListeners(nextOnEvents);
      }

      if (!shallowEqual(nextOption, option)) {
        this.updateChart(nextOption);
      }

      if (nextWidth !== width || nextHeight !== height) {
        this._shouldResize = true;
      }

      if (nextLoading !== loading) {
        if (nextLoading) {
          echartsInstance.showLoading('default', loadingStyle);
        } else {
          echartsInstance.hideLoading();
        }
      }
    }

    /**
     * @public
     * @returns {void}
     */

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this._shouldResize) {
        this.echartsInstance.resize();
        this._shouldResize = false;
      }
    }

    /**
     * @public
     * @returns {void}
     */

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var onEvents = this.props.onEvents,
          echartsInstance = this.echartsInstance;


      this.removeListeners(onEvents);
      echartsInstance.dispose();
    }

    /**
     * @public
     * @var {HTMLElement}
     */


    /**
     * @public
     * @var {object}
     */


    /**
     * @private
     * @var {boolean}
     */


    /**
     * @private
     * @param {HTMLElement} node
     * @returns {void}
     */

  }, {
    key: 'listenersEqual',


    /**
     * @public
     * @param {object|void} a
     * @param {object|void} b
     * @return {boolean}
     */
    value: function listenersEqual(a, b) {
      if (a === b) {
        return true;
      }

      var aEntries = _Object$entries(a);
      var bEntries = _Object$entries(b);

      if (aEntries.length !== bEntries.length) {
        return false;
      }

      return aEntries.every(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            key = _ref3[0],
            listener = _ref3[1];

        return b[key] === listener;
      });
    }

    /**
     * @public
     * @param {object} option
     * @return {void}
     */

  }, {
    key: 'updateChart',
    value: function updateChart(option) {
      var _props2 = this.props,
          merge = _props2.merge,
          lazy = _props2.lazy,
          silent = _props2.silent,
          echartsInstance = this.echartsInstance;


      echartsInstance.setOption(option, { noMerge: !merge, lazyUpdate: lazy, silent: silent });
    }

    /**
     * @public
     * @param {object|void} listeners
     * @returns {void}
     */

  }, {
    key: 'addListeners',
    value: function addListeners(listeners) {
      if (!listeners) {
        return;
      }

      var echartsInstance = this.echartsInstance;


      _Object$entries(listeners).forEach(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            event = _ref5[0],
            listener = _ref5[1];

        if (listener) {
          validateListener(listener);
          echartsInstance.on(event, listener);
        }
      });
    }

    /**
     * @public
     * @param {object|void} listeners
     * @returns {void}
     */

  }, {
    key: 'removeListeners',
    value: function removeListeners(listeners) {
      if (!listeners) {
        return;
      }

      var echartsInstance = this.echartsInstance;


      _Object$entries(listeners).forEach(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
            event = _ref7[0],
            listener = _ref7[1];

        if (listener) {
          validateListener(listener);
          echartsInstance.off(event, listener);
        }
      });
    }

    /**
     * @public
     * @returns {object}
     */

  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          width = _props3.width,
          height = _props3.height,
          theme = _props3.theme,
          option = _props3.option,
          loadingStyle = _props3.loadingStyle,
          merge = _props3.merge,
          lazy = _props3.lazy,
          silent = _props3.silent,
          loading = _props3.loading,
          onEvents = _props3.onEvents,
          classNameProp = _props3.className,
          styleProp = _props3.style,
          children = _props3.children,
          otherPorps = _objectWithoutProperties(_props3, ['width', 'height', 'theme', 'option', 'loadingStyle', 'merge', 'lazy', 'silent', 'loading', 'onEvents', 'className', 'style', 'children']),
          _echartsContainerRef = this._echartsContainerRef;

      var className = cs(classNameProp);
      var style = _extends({}, styleProp, {
        width: width,
        height: height
      });

      return React.createElement('div', _extends({}, otherPorps, {
        ref: _echartsContainerRef,
        className: className,
        style: style
      }));
    }
  }]);

  return Echart;
}(Component);

Echart.defaultProps = {
  height: 600,
  option: {},
  merge: true,
  loading: false };


if (process.env.NODE_ENV !== 'production') {
  Echart.propTypes = {
    theme: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    loadingStyle: PropTypes.object,
    option: PropTypes.object,
    merge: PropTypes.bool,
    lazy: PropTypes.bool,
    silent: PropTypes.bool,
    loading: PropTypes.bool,
    onEvents: PropTypes.object,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    // eslint-disable-next-line react/forbid-prop-types
    className: PropTypes.any,
    style: PropTypes.object,
    // eslint-disable-next-line react/forbid-prop-types
    children: PropTypes.any
  };
}

export default Echart;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lyjs/es/components/Echart/Echart.js
// module id = 794
// module chunks = 0